export default __webpack_public_path__ + "images/0x00e8c0e92eb3ad88189e7125ec8825edc03ab265.png";